import React, { Component } from 'react';
import { connect } from "react-redux";
import TopBottomFiveChart from '../../components/bar-charts/TopBottomFiveChart';
import CustomSelect from "../../components/common/select/Select";
import PratDashboardMiddleware from '../../store/prat_middleware/pratDashboard/pratDashboardMiddleware';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import DATA from '../../assets/data';
import { compare } from '../gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

class TopBottomActivities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: [],
            selectedYear: '',
            selectedMonth: [],
            selectedPromoType: [],
            data: [],
            popUp: false,
            months: DATA.QUARTER_MONTHS,
            years: DATA.YEARSPreVsPostOpso,
            promotionTypes: DATA.PROMO_TYPES
        };
    }

    componentDidMount() {

        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        let currentYearIndex = this.state.years.findIndex(year => year.value === currentYear);

        this.handleYearCheckonMounting(currentYearIndex)      // Marking current Year Check on component mounting

        let arr = []
        if (this.props.categories) {
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                setTimeout(() => {
                    this.handleSubmit()
                }, 1000)
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.categories !== this.props.categories) {
            let arr = []
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                this.handleSubmit();
            })
        }
    }

    handleCategory = (category) => {
        let arr = [];
        if (category === null || category.length === 0) {
            this.setState({
                selectedCategory: []
            }, () => {
                this.handleSubmit()
            });
        } else {
            category.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({ selectedCategory: arr }, () => {
                this.handleSubmit()
            });
        }
    };

    handleSubmit = () => {
        if (this.state.selectedCategory.length) {
            if (this.state.selectedYear.length) {
                this.props.getTopBottomActivites(
                    this.state.selectedCategory,
                    this.state.selectedYear,
                    this.state.selectedMonth,
                    this.state.selectedPromoType
                );
            }
            else {
                // ToastsStore.error('Year is not selected!')
                CustomToast('error', 'Year is not selected!')
            }
        } else {
            // ToastsStore.error('Category is not selected!')
            CustomToast('error', 'Category is not selected!')
        }
    }

    handleMonthCheck = (ind) => {
        let newArray = [...this.state.months]
        newArray[ind] = { ...newArray[ind], topBottomChecked: !newArray[ind].topBottomChecked }
        // this.state.months[ind].topBottomChecked = !this.state.months[ind].topBottomChecked
        this.setState({
            months: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.months.forEach(item => {
                    if (item.topBottomChecked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedMonth: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })

    }

    handleYearCheck = (ind) => {
        let newArray = [...this.state.years]
        newArray[ind] = { ...newArray[ind], topBottomChecked: !newArray[ind].topBottomChecked }
        // this.state.years[ind].topBottomChecked = !this.state.years[ind].topBottomChecked
        this.setState({
            years: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.years.forEach(item => {
                    if (item.topBottomChecked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedYear: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })
    }

    handleYearCheckonMounting = (ind) => {
        this.state.years[ind].topBottomChecked = true       // eslint-disable-line
        this.setState({
            years: this.state.years
        },
            () => {
                let filterCheckedValues = []
                this.state.years.forEach(item => {
                    if (item.topBottomChecked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedYear: filterCheckedValues
                })
            })
    }

    handlePromoTypeCheck = (ind) => {
        let newArray = [...this.state.promotionTypes]
        newArray[ind] = { ...newArray[ind], topBottomChecked: !newArray[ind].topBottomChecked }
        // this.state.promotionTypes[ind].topBottomChecked = !this.state.promotionTypes[ind].topBottomChecked
        this.setState({
            promotionTypes: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.promotionTypes.forEach(item => {
                    if (item.topBottomChecked) {
                        filterCheckedValues.push(item.guid)
                    }
                })
                this.setState({
                    selectedPromoType: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })
    }

    render() {
        return (
            <div className='activation-metrics-container'>

                <div className='activation-metrics-heading-cta'>

                    <span className='activation-metrics-heading' style={{ width: 'fit-content' }}>Top & Bottom Five Activities</span>

                    <CustomSelect.MyCustomSelect
                        className='filter-font-size'
                        placeholder={"Category"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.props.categories
                                ? !this.props.categories
                                    ? void 0
                                    : this.props.categories.sort(compare).map(item => ({
                                        value: item.guid,
                                        label: item.Name
                                    }))
                                : []
                        }
                        onChange={this.handleCategory}
                        value={
                            this.props.categories
                                ? this.props.categories
                                    .filter(item => {
                                        return !this.state.selectedCategory
                                            ? void 0
                                            : this.state.selectedCategory.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Name
                                        };
                                    }) : void 0
                        }
                    />
                    <div className='cta-container'>
                        <div className='funnel-filter-container'>
                            <img alt='' className='funnel-filter-image' src={require('../../assets/images/funnelFilter.svg')} onClick={() => { this.setState({ popUp: !this.state.popUp }) }} />
                            {/* Funnel Icon Popup Filter */}
                            {this.state.popUp ?
                                <ClickAwayListener onClickAway={() => { this.setState({ popUp: false }) }}>
                                    <div className='funnel-pop-up'>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Type of Promo</span>

                                            <div className='promo-column'>
                                                {this.state.promotionTypes.map((item, indx) => (
                                                    <span className='column-item' key={indx}>
                                                        <input type='checkbox' className='column-item-input' checked={item.topBottomChecked}
                                                            onChange={() => this.handlePromoTypeCheck(indx)} />
                                                        <label>{item.Label}</label>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Month</span>
                                            <div className='month-column'>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind <= 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.topBottomChecked}
                                                                        onChange={() => this.handleMonthCheck(indx)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind > 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.topBottomChecked}
                                                                        onChange={() => this.handleMonthCheck(indx + 6)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Year</span>
                                            <div className='promo-column'>
                                                {
                                                    this.state.years.map((item, indx) => (
                                                        <span className='column-item' key={indx}>
                                                            <input type='checkbox' className='column-item-input' checked={item.topBottomChecked}
                                                                onChange={() => this.handleYearCheck(indx)} />
                                                            <label>{item.label}</label>
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </ClickAwayListener>
                                :
                                null
                            }
                        </div>
                        <img alt='' className='images-style' src={require('../../assets/images/refreshArrows.svg')} onClick={this.handleSubmit} />
                        <img alt='' className='image-transform' src={require('../gt/images/dots.png')} />
                    </div>

                </div>

                {this.props.isTopBottomActivitiesLoading ?
                    <div style={{ marginTop: '100px' }}>
                        {/* Loading */}
                        <img alt='' src={require('../../assets/images/barsLoader.svg')} style={{ width: '60px', height: '60px' }} />
                    </div>
                    :
                    <div className='chart-legend-container'>

                        {/* Graph */}
                        <TopBottomFiveChart data={this.props?.topBottomActivities} type='top' />

                        {/* Legends */}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <span style={{ display: 'flex', alignItems: 'center', marginRight: '12px', fontSize: '12px', fontWeight: '600' }}>
                                    <span style={{ width: '8px', height: '8px', backgroundColor: '#0353a4', marginRight: '8px' }}></span>
                                    <span>Top</span>
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '600' }}>
                                    <span style={{ width: '8px', height: '8px', backgroundColor: '#a9bcd0', marginRight: '8px' }}></span>
                                    <span>Bottom</span>
                                </span>
                            </div>
                        </div>
                    </div>}

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        topBottomActivities: state.PratDashboardReducer.topBottomActivities,
        isTopBottomActivitiesLoading: state.PratDashboardReducer.isTopBottomActivitiesLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTopBottomActivites: (
            selectedCategory,
            selectedYear,
            selectedMonth,
            selectedPromoType) => {
            return dispatch(PratDashboardMiddleware.getTopBottomActivites(
                selectedCategory,
                selectedYear,
                selectedMonth,
                selectedPromoType));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TopBottomActivities);
